/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_CUL_COSTOS_ITEM = {
  id: 'agro_cultivos_costos',
  screenId: 'agr-cul-costos',
  label: 'Costos',
  description: 'Costo de una campaña: insumos, gastos directos y mano de obra.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Al terminar la campaña ves cuánto costó, en total y por hectárea. El cálculo junta tres cosas: lo que se aplicó en el campo, los gastos de cuentas como gasoil o energía, y los sueldos.',
      },
      {
        title: 'Paso 1 — Elegir la campaña',
        bullets: [
          'Arriba elegís la campaña.',
          'Las pestañas son Informe, Cuentas de gasto, Sueldos e Imputación manual.',
        ],
      },
      {
        title: 'Paso 2 — Insumos',
        paragraphs: [
          'Fertilizantes y fitosanitarios que están vinculados a un artículo de stock se costean solos cuando los registrás en Eventos (cantidad consumida y almacén).',
          'El valor sale del precio de compra, en el orden en que entró la mercadería (lo primero que se compró es lo primero que se consume).',
          'Si una línea dice «sin costo FIFO», falta la factura de esa compra.',
        ],
      },
      {
        title: 'Paso 3 — Cuentas de gasto',
        bullets: [
          'En «Cuentas de gasto» asignás un porcentaje de una cuenta (por ejemplo Gasoil) a la campaña.',
          'Podés limitarlo a una siembra y a un rango de fechas. Si no ponés fechas, vale toda la campaña.',
          'La suma de porcentajes de la misma cuenta, en fechas que se pisan, no puede pasar de 100.',
          'Después tocá Recalcular en el informe.',
        ],
      },
      {
        title: 'Paso 4 — Sueldos',
        bullets: [
          'En «Sueldos» indicás qué porcentaje del costo laboral de cada empleado va a la campaña.',
          'El costo laboral es el recibo cerrado: remunerativo, no remunerativo y contribuciones patronales.',
          'Si en un evento cargaste horas de ese empleado, esas horas se descuentan primero y el porcentaje se aplica sobre lo que queda.',
        ],
      },
      {
        title: 'Paso 5 — Ajuste manual',
        paragraphs: [
          'En «Imputación manual» ves facturas de proveedor y pagos a cuentas de gasto del período que todavía no están imputados. Podés asignar el total o una parte.',
          'También podés cargar un importe a mano, sin comprobante.',
        ],
      },
      {
        title: 'Informe y cierre',
        bullets: [
          'El informe muestra el total, el costo por hectárea, el detalle por tipo, por cuenta y por siembra.',
          'Lo que no tiene siembra se reparte entre las siembras según las hectáreas.',
          '«Cerrar costos» bloquea el recálculo y las cargas. «Reabrir costos» los vuelve a habilitar.',
        ],
      },
    ],
  },
};
